import { compose } from 'lodash/fp';

import { maskedInputFactory } from '../maskedInput';

import NumberMaskInput from './NumberMaskInput';

export const createNumberMask = compose(NumberMaskInput, maskedInputFactory);
